// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"507339ce","690":"8d5a2d6d","742":"5cf1c937"}[chunkId] + ".chunk.js";
};